<!--Banner: 版本介绍-banner 2021/03/25 13:38:05 Sunanguang-->

<template>
   <div class="its-banner" :class="type">
     <ts-page-layout center class="its-banner-container">
       <div class="its-banner-left">
         <p class="its-banner-title" v-html="item.title"></p>
         <p v-if="type==='interact'" class="its-banner-sub-title">(须搭配学生平板使用，欢迎了解学科网<span @click="toEpad">ePad学生平板</span>)</p>
         <p class="its-banner-desc" v-html="item.desc"></p>
         <div class="its-btns">
           <button class="its-btn its-apply-btn" @click="toPath('/apply/submit')">立即试用</button>
           <button v-if="type !== 'area'" class="its-btn its-download-btn" @click="getDownloadByIdentity(type==='enjoy' ? 'EASY_CLASS_PC' : 'EASY_CLASS_PC')">
             <i class="its-icon its-icon-diannao"></i>下载e课堂教师电脑端
            </button>
         </div>
       </div>
       <div class="its-banner-right"></div>
     </ts-page-layout>
   </div>
</template>
<script>
import {downloadCenterApi} from '@/utils/api'
export default {
  name: 'Banner',
  props: {
    type: {
      type: String,
      default: 'interact'
    },
    item:  {
      type: Object,
      default: function () {
          return {
            title: '全场景常态化智慧教学解决方案',
            desc: '将智慧教育平台与教学场景紧密结合，专业的教研内容，<br>多样的趣味互动应用，让教与学更高效。'
          }
      }
    }
  },
  data () {
    return {
      appDownloads: []
    }
  },
  created () {
    this.getAppDownloads()
  },
  methods: {
    toPath: function (path, tab) {
      if (!tab) {
        tab = this.type
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.$router.push(path+'?tab=' + tab)
    },
    toEpad: function () {
      window.open('#/eclass/ePad', '_blank')
    },
    getAppDownloads: function () {
      downloadCenterApi.getAllOnlineAppDownload().then((res) => {
        console.log(res)
        if (res.success) {
          this.appDownloads = res.body
          console.log('tabs new', this.tabs)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDownloadByIdentity: function (identity) {
      let app = {}
      this.appDownloads.forEach((item) => {
        if (item.identity === identity) {
          app = item
          return
        }
      })
      window.location.href = app.url
      // this.tabs.forEach((tab) => {
      //       let download = this.getDownloadByIdentity(tab.item.identity)
      //       tab.item.downloadUrl = download.url
      //     })
    }
  }
}
</script>

<style scoped>
.its-banner {
  width: 100%;
  height: 774px;
  background-repeat: no-repeat;
  background-size: 100% 774px;
  background-color: #406DF3;
}

.its-banner.interact {
  background-image: url(../../../../../assets/images/edition/interact_banner.png);
}

.its-banner.enjoy {
  background-image: url(../../../../../assets/images/edition/enjoy_banner.png);
}

.its-banner.area {
  background-image: url(../../../../../assets/images/edition/interact_banner.png);
}

.its-banner-container {
  position: relative;
}

.its-banner-left {
  position: absolute;
  top: 272px;
}

.interact .its-banner-left {
  top: 272px;
}

.its-banner-right {
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
}

.interact .its-banner-right{
  background-image: url(../../../../../assets/images/edition/interact_bg.png);
  width: 679px;
  height: 424px;
  top: 218px;
}

.enjoy .its-banner-right{
  background-image: url(../../../../../assets/images/edition/enjoy_bg.png);
  width: 504px;
  height: 509px;
  top: 181px;
}

.area .its-banner-right{
  background-image: url(../../../../../assets/images/area/area_bg.png);
  width: 788px;
  height: 566px;
  top: 120px;
  right: -100px;
}


.its-banner-title {
  font-size: 36px;
  color: white;
  margin-bottom: 28px;
}

.its-banner-sub-title {
  margin-bottom: 28px;
  font-size: 16px;
  color: white;
}

.its-banner-sub-title span {
  cursor: pointer;
  color: #F6CF46;
  font-weight: bold;
  border-bottom: 1px solid #F6CF46;
  margin: 0 5px;
  padding-bottom: 5px;
}

.its-banner-desc {
  font-size: 17px;
  color: white;
  line-height: 1.5;
}

.interact .its-banner-title {
  color: white;
  margin-bottom: 5px;
}

.its-btns {
  margin-top: 48px;
}

.interact .its-btns {
  margin-top: 80px;
}

.its-btn {
  float: left;
  cursor: pointer;
  color: white;
  border: 1px solid white;
  border-radius: 24px;
  height: 48px;
  line-height: 44px;
  text-align: center;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0);
}

.its-apply-btn {
  width: 200px;
}

.its-download-btn {
  width: 278px;
  margin-left: 20px;
}

.its-apply-btn:hover,
.its-download-btn:hover {
  background-color: white;
  color: #406DF3;
}

.its-icon {
  font-size: 20px;
  margin-right: 5px;
  vertical-align: middle;
}
</style>